export enum TenantExecutionStatus{
    Succeeded = 0, 
    Executing = 1,
    Unknown  = 4     

}

export enum TenantJobExecutionStatus{
    Failed = 0,
    Succeeded = 1,
    Unknown = 5
}
